import React from "react";

export default function CompleteApplication({ setCurrentStep }) {
  // Navigation function
  const handleContinue = () => {
    setCurrentStep(8); // Move to Work Details step
  };

  const checklistItems = [
    { regular: "Complete your ", bold: "work details" },
    { regular: "Verify your ", bold: "Aadhaar" },
    { regular: "Confirm your ", bold: "bank account" },
    { regular: "Review & accept your ", bold: "final loan offer" },
    { regular: "Sign & submit your ", bold: "application" }
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto bg-[#FAFAFA] min-h-[100dvh] font-atkinson flex flex-col relative pb-[120px]">

      {/* Header Section (No Progress Bar in this specific step based on Figma) */}
      <div className="px-5 pt-6 pb-2">
        <button
          onClick={() => setCurrentStep(6)}
          className="w-6 h-6 flex items-center justify-start text-[#1b1b1b] mb-5 hover:opacity-70 transition-opacity"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="text-[24px] font-bold text-[#1b1b1b] tracking-tight leading-tight">
          Let's Complete your Application
        </h1>
        <p className="text-[14px] text-[#A3A3A3] font-normal mt-2 leading-snug pr-4">
          Your offer is selected. Just a few quick steps remain.
        </p>
      </div>

      {/* Main Checklist Card */}
      <div className="border border-[#E5E5E5] rounded-[20px] p-4 bg-white mx-5 mt-6 shadow-[0_2px_10px_rgba(0,0,0,0.02)]">

        {/* Card Header with Image Fallback */}
        <div className="flex items-center gap-2.5 mb-3 px-1">
          {/* Replace this image in your public/assets folder to match the curved arrow perfectly */}
          <img
            src="/assets/icons/Next.svg"
            alt="Next steps arrow"
            className="w-[20px] h-[20px] object-contain"
          />
          <h3 className="text-[17px] font-bold text-[#1b1b1b] tracking-tight">What's next?</h3>
        </div>

        {/* Compact List Items */}
        <div className="flex flex-col">
          {checklistItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3.5 py-3 ${i !== checklistItems.length - 1 ? 'border-b border-[#F0F0F0]' : 'pb-1'
                }`}
            >
              <div className="w-[22px] h-[22px] rounded-full bg-[#1b1b1b] flex items-center justify-center flex-none">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <p className="text-[14.5px] text-[#6b6b6b] leading-tight font-medium">
                {item.regular} <span className="font-bold text-[#1b1b1b]">{item.bold}</span>
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Time Estimate Badge & Disclaimer */}
      <div className="mt-7 flex flex-col items-center px-6">

        {/* Green Badge */}
        <div className="flex items-center gap-1.5 bg-[#EEF9F2] border border-[#D5EFE0] rounded-full px-3.5 py-[5px] mb-4">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#35614C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <span className="text-[11.5px] font-semibold text-[#35614C] tracking-wide">
            Takes about 2–3 minutes
          </span>
        </div>

        {/* Disclaimer Text */}
        <p className="text-[13px] text-[#7A7A7A] text-center leading-relaxed font-medium">
          Once completed, your loan will be<br />disbursed <span className="font-bold text-[#1b1b1b]">within 1 hour.</span>
        </p>
      </div>

      {/* Sticky Bottom Button */}
      <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-gradient-to-t from-[#FAFAFA] via-[#FAFAFA] to-transparent px-5 pt-10 pb-6">
        <button
          onClick={handleContinue}
          className="w-full bg-black text-white font-bold text-[17px] rounded-[16px] py-[18px] active:scale-[0.98] transition-transform shadow-lg shadow-black/10"
        >
          Complete your application
        </button>
      </div>
    </div>
  );
}